





















































import Vue from 'vue';
import { kebabCase, startsWith, union, without } from 'lodash';
import { BLink, BFormCheckboxGroup } from 'bootstrap-vue';

import { Attribute } from '../types';

export default Vue.extend({
  name: 'AttributeCheckboxes',
  components: {
    BFormCheckboxGroup,
    BLink,
  },
  props: {
    value: {
      type: Array as () => Attribute[],
      required: true,
    },
    quickSelection: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    regularAttributes(): Attribute[] {
      return this.value.filter(
        attribute =>
          // '__mapping__:' is for REST API, 'mappings.' is for GraphQL
          !startsWith(attribute.key, 'mappings.') &&
          !startsWith(attribute.key, '__mapping__:') &&
          // '__custom__:' is for REST API, 'ca__' is for GraphQL
          !startsWith(attribute.key, 'ca__') &&
          !startsWith(attribute.key, '__custom__:')
      );
    },
    customAttributes(): Attribute[] {
      return this.value.filter(
        attribute => startsWith(attribute.key, 'ca__') || startsWith(attribute.key, '__custom__:')
      );
    },
    mappingAttributes(): Attribute[] {
      return this.value.filter(
        attribute => startsWith(attribute.key, 'mappings.') || startsWith(attribute.key, '__mapping__:')
      );
    },
    allAttributes() {
      const addIfHasElements = (k, arr) => arr.length && { [k]: arr };

      return {
        ...addIfHasElements('Regular Attributes', this.regularAttributes),
        ...addIfHasElements('Custom Attributes', this.customAttributes),
        ...addIfHasElements('Mappings', this.mappingAttributes),
      };
    },
    checked(): string[] {
      return this.value.filter(attribute => attribute.checked).map(attribute => attribute.key);
    },
  },
  methods: {
    kebabCase,
    updateAttributes(newChecked: string[]) {
      const newAttributes = this.value.map(attribute => {
        const shouldBeChecked = newChecked.includes(attribute.key);
        if (shouldBeChecked === attribute.checked) {
          return attribute;
        } else {
          return { ...attribute, checked: shouldBeChecked };
        }
      });

      this.$emit('input', newAttributes);
    },
    massUncheck(attributes: Attribute[]) {
      this.massCheck(attributes, false);
    },
    massCheck(attributes: Attribute[], checkAll = true) {
      const attributeKeys = attributes.filter(attribute => !attribute.disabled).map(attribute => attribute.key);

      let newChecked;
      if (checkAll) {
        newChecked = union(this.checked, attributeKeys);
      } else {
        newChecked = without(this.checked, ...attributeKeys);
      }

      this.updateAttributes(newChecked);
    },
  },
});
